"use client";

import { SubjectsDisplay } from "@/features/profile/tutor/components/profile-page/SubjectsSection/SubjectsDisplay.tsx";

export function SubjectsSection() {
  return (
    <div>
      <SubjectsDisplay />
    </div>
  );
}
